/* ==========================================================================
   FYP NAV PREFETCH - hover-intent panel hydration.  5 Aug 2026 (Nav PERF r2)

   THE SYMPTOM THIS EXISTS FOR
   Will: "the menu seems to load in one item at a time". Measured: the header
   carries 123 images, all loading="lazy" inside panels that are hidden until
   opened. Nothing loads at page load - correct - but the moment a panel opens,
   its images all start from zero and paint in whatever order they arrive. The
   Brands panel alone is 36 logos. That arrival order IS the one-at-a-time feel.

   WHAT THIS DOES
   On the FIRST pointerenter / focus / touchstart of a top-level nav trigger -
   i.e. while the pointer is travelling toward it, before the panel is open - the
   matching panel's lazy images are promoted to eager and decoded off the main
   thread. By the time the panel paints, they are usually already there.
   Measured: Footwear (6 images) 378ms, Brands (36 logos) 921ms, menu never opened.

   WHY IT IS SAFE
   Purely additive. The markup is untouched: every image keeps loading="lazy" and
   its real src, so with JavaScript off, or if this file fails to load, behaviour
   is exactly what it is today. Nothing here can leave an image unloaded. It also
   never runs twice per panel - the hydrate flag and {once:true} see to that.

   DELIBERATELY NOT DONE: deferring the panel markup into <template>. That would
   cut ~2,000 nodes from the initial DOM, but Impact's mega-menu-disclosure element
   and fyp-nav.js's carousel both query their panels at parse time, so it changes a
   contract those two rely on. Higher risk than the symptom warrants.
   ========================================================================== */
(function () {
  'use strict';

  var FLAG = 'fypNavHydrated';
  var PRIORITY_COUNT = 8;   // first N get fetchpriority=high
  var DECODE_LIMIT = 12;    // don't queue 36 decodes at once

  function hydrate(panel) {
    if (!panel || panel.dataset[FLAG]) return;
    panel.dataset[FLAG] = '1';

    var imgs = panel.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.setAttribute('loading', 'eager');
      if (i < PRIORITY_COUNT) img.setAttribute('fetchpriority', 'high');
      if (i < DECODE_LIMIT && typeof img.decode === 'function') {
        try { img.decode().catch(function () {}); } catch (e) { /* decode is best-effort */ }
      }
    }
  }

  function panelFor(trigger) {
    var details = trigger.closest && trigger.closest('details');
    if (details) {
      var inline = details.querySelector('.mega-menu, .dropdown-menu');
      if (inline) return inline;
    }
    var controls = trigger.getAttribute('aria-controls');
    if (controls) return document.getElementById(controls);
    return null;
  }

  function arm(root) {
    if (!root || !root.querySelectorAll) return;

    var triggers = root.querySelectorAll(
      '.header__link-list summary, .header__link-list button[aria-controls], [aria-controls="header-sidebar-menu"]'
    );

    Array.prototype.forEach.call(triggers, function (trigger) {
      if (trigger.dataset.fypArmed) return;
      trigger.dataset.fypArmed = '1';

      var go = function () { hydrate(panelFor(trigger)); };

      trigger.addEventListener('pointerenter', go, { once: true, passive: true });
      trigger.addEventListener('focus', go, { once: true });
      trigger.addEventListener('touchstart', go, { once: true, passive: true });
    });
  }

  function init() { arm(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor and any Section Rendering API re-render of the header. */
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
})();
